export default {
    chamadas: {
        dados:[],
        sumario:{
            atendidas:'-',
            naoatendidas:'-',
            falhas:'-',
            duracao:'-'
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/protaxi/state.js